import { AxiosResponse } from 'axios'

export const mapFileStreamToFile = (httpResponse: AxiosResponse<any>): File => {
  if (httpResponse.data instanceof Blob) {
    const contentDisposition = httpResponse.headers['content-disposition']
    let fileName = 'downloadedFile'
    if (contentDisposition) {
      // Busca filename*=UTF-8''nombre.ext
      let matches = contentDisposition.match(/filename\*=UTF-8''([^;]+)/)
      //  const matches = contentDisposition.match(/filename\*=[^']*''([^']+)/)

      if (!matches) {
        // Busca filename=nombre.ext (con o sin comillas, con o sin punto y coma)
        matches = contentDisposition.match(/filename="?([^";]+)"?/)
      }

      if (matches) {
        // Decodificar el nombre de archivo utilizando la codificación UTF-8
        fileName = decodeURIComponent(matches[1])
      }
    }
    // const date = new Date(httpResponse.headers['date']).getTime()
    const file = new File([httpResponse.data], fileName)
    return file
  } else {
    throw new Error('response does not contain blob')
  }
}
